import { Box, Button, Typography } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { PageBreadcrumbs } from '@/components/common/PageBreadcrumbs'
import { PageHelpPopover } from '@/components/common/PageHelpPopover'
import { ExerciseCheckForm } from '@/components/exercises/ExerciseCheckForm'
import { ROUTES } from '@/utils/constants'

/**
 * Проверка сданной работы отдельной страницей — вход из очереди «На проверке».
 *
 * Сама форма общая с уроком: работу, сданную на занятии, учитель проверяет там
 * же, не уходя со страницы урока.
 */
export function ExerciseCheckPage() {
  const { id } = useParams<{ id: string }>()
  const runId = Number(id)
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <DashboardLayout>
      {/* Те же отступы, что на соседних страницах: без обёртки контент
          прижимался к краю, и переход из очереди дёргал вёрстку */}
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <PageBreadcrumbs
          items={[
            { label: t('exercises.review.title'), to: ROUTES.EXERCISE_REVIEW },
            { label: t('exercises.check.title') },
          ]}
        />
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(ROUTES.EXERCISE_REVIEW)}>
            {t('common.back')}
          </Button>
          <Typography variant="h4" component="h1" fontWeight={700} sx={{ flex: 1 }}>
            {t('exercises.check.title')}
          </Typography>
          <PageHelpPopover pageKey="exercise-review" />
        </Box>

        <ExerciseCheckForm runId={runId} onChecked={() => navigate(ROUTES.EXERCISE_REVIEW)} />
      </Box>
    </DashboardLayout>
  )
}
